module.exports = __webpack_public_path__ + "static/media/n.a4bb08a8.png";